<template>
<div class="radio-container" v-bind:class="{'radio-disabled':disabled}">
  <div class="radio-group" :class="{oth: ($route.query.oth === null)}" @click="toggle()">
    <input type="radio" :id="id || uniqueId" :name="name" :value="radioValue" :disabled="disabled" :required="required" :color="color" :selected="radioButtonState"
    class="ga-event" :data-category="gacategory" :data-eventlabel="gatext" :data-eventvaluetype="gavaluetype" :data-eventvalue="gavalue">

    <label class="checkbox_label" :for="id || uniqueId">
      <slot />
    </label>
  </div>
</div>
</template>

<script>
export default {
  name: 'RadioButton',

  props: {
    id: {
      type: String,
      default: undefined,
    },
    selectedValue: null,
    radioValue: null,
    name: String,
    required: Boolean,
    disabled: Boolean,
    color: String,
    gacategory: null,
    gatext: null,
    gavaluetype: null,
    gavalue: null,
  },
  data() {
    return {
      uniqueId: '',
      selected: false,
      dupcheck: 0,
    };
  },
  computed: {
    radioButtonState() {
      if (this.selectedValue == this.radioValue) {
        this.selected = true;
      }

      return this.selected;
    },
  },
  methods: {
    toggle() {
      if (this.disabled) return;

      if (this.dupcheck == 0) {
        this.dupcheck = 1;
        this.$emit('input', this.radioValue);
      } else {
        this.dupcheck = 0;
        return;
      }
    },
  },
  watch: {
    selectedValue(newVal) {
      if (newVal != this.radioValue) {
        this.selected = false;
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.radio-container {
    margin: 0 20px 0 0;
    padding: 0;

    @screen lg {
        margin: 0 23px 0 0;
    }

    @media (min-width: 1024px) and (max-width: 1120px) {
        margin: inherit;
    }

    @screen xl {
        margin: 0 15px 0 0;
    }

    &:hover {
        svg {
            margin-bottom: 31px;
            g,
            path {
                fill: #fff;
            }
        }
        .radio-group {
            background-color: #00AB64;
            color: #fff;
        }
        .radio-group.oth {
            background-color: #2c96ff;
            color: #fff;
        }
    }

    &.radio-active {
        svg {
            margin-bottom: 30px;
            g,
            path {
                fill: #fff;
            }
        }
        .radio-group {
            background-color: #00AB64;
            color: #fff;
        }
        .radio-group.oth {
            background-color: #2c96ff;
            color: #fff;
        }
    }

    .custom {
        font-size: 42px;
        letter-spacing: -1.05px;
        line-height: 51px;
        margin-bottom: 7px;

        @screen lg {
            margin-bottom: 25px;
        }
    }

    .checkbox_label {
        div {
            min-height: 48px;
        };
        padding: 28% 3%;
        box-sizing: content-box;
    }

    .radio-group {
        @apply ut-text-center ut-cursor-pointer;
        border: 1px solid #00AB64;
        background-color: #fff;
        z-index: 1;
        border-radius: 5px;
        color: #00AB64;
        max-width: 153px;
        min-width: 153px;
        max-height: 153px;
        min-height: 153px;
        font-size: 16px;
        letter-spacing: 0.3px;
        position: relative;

        @screen xl {
            max-width: 160px;
            min-width: 160px;
            max-height: 212px;
            min-height: 212px;
        }

        @media (max-width: 360px) {
            max-width: 130px;
            min-width: 130px;
            max-height: 130px;
            min-height: 130px;
        }

        label {
            @apply ut-cursor-pointer;
            font-size: 16px;
            letter-spacing: 0.3px;
            position: absolute;
            top: 50%;
            left: 50%;
            max-height: 110px;
            transform: translate(-50%, -50%);
            width: 100%;

            span {
                display: block;
                margin-top: 8px;

                @screen lg {
                    margin-top: 25px;
                }
            }
        }

        //Hide input
        input {
            border: 0;
            clip: rect(0 0 0 0);
            height: 1px;
            margin: -1px;
            overflow: hidden;
            padding: 0;
            display: none;
            // position: absolute;
            width: 1px;
        }
    }
    .radio-group.oth {
        border: 1px solid #2c96ff;
        color: #2c96ff;
        background-color: #fff;
    }
}
</style>
